const SELF_PICKUP_DELIVERY_CODE = 5;

export interface DeliveryProgressGoodsInfo {
    deliveryQuantity?: unknown;
}

export interface DeliveryProgressShipOrder {
    ton?: unknown;
}

export interface DeliveryProgressVehicleOrder {
    transportWeight?: unknown;
}

export interface DeliveryProgressRailwayOrder {
    transportWeight?: unknown;
}

export interface DeliveryActualGoodsSource {
    delivery?: number | null;
    goodsInfo?: string | DeliveryProgressGoodsInfo[] | null;
    actualGoodsTotalQuantity?: unknown;
    transportOrderShips?: DeliveryProgressShipOrder[] | null;
    transportOrderVehicles?: DeliveryProgressVehicleOrder[] | null;
    transportOrderRailways?: DeliveryProgressRailwayOrder[] | null;
}

// 统一把接口数量字段转成 number，避免空值或字符串导致进度汇总失真。
export const getSafeDeliveryQuantity = (value: unknown) => {
    const quantity = Number(value);
    return Number.isFinite(quantity) ? quantity : 0;
};

// 自提明细可能是 JSON 字符串或数组，解析失败时按空数组处理，避免单条异常拖垮整页。
export const parseDeliveryGoodsInfo = (goodsInfo: DeliveryActualGoodsSource["goodsInfo"]) => {
    if (Array.isArray(goodsInfo)) return goodsInfo;
    if (!goodsInfo || typeof goodsInfo !== "string") return [] as DeliveryProgressGoodsInfo[];
    try {
        const parsedGoodsInfo = JSON.parse(goodsInfo);
        return Array.isArray(parsedGoodsInfo) ? (parsedGoodsInfo as DeliveryProgressGoodsInfo[]) : ([] as DeliveryProgressGoodsInfo[]);
    } catch (error) {
        console.error("解析发货明细 goodsInfo 失败", error);
        return [] as DeliveryProgressGoodsInfo[];
    }
};

// 当前发货/提货单实际数量以本单明细为准，不能使用接口里的订单级累计实际数量。
export const getCurrentDeliveryActualGoodsTotalQuantity = (source: DeliveryActualGoodsSource) => {
    if (source.delivery === SELF_PICKUP_DELIVERY_CODE) {
        const selfPickupGoodsInfo = parseDeliveryGoodsInfo(source.goodsInfo);
        const selfPickupQuantity = selfPickupGoodsInfo.reduce((total, item) => {
            return total + getSafeDeliveryQuantity(item.deliveryQuantity);
        }, 0);
        // 自提明细存在时，0 也是有效的当前单实际发货数，不能回退到订单级累计数量。
        return selfPickupGoodsInfo.length ? selfPickupQuantity : getSafeDeliveryQuantity(source.actualGoodsTotalQuantity);
    }

    const shippingQuantity = (source.transportOrderShips || []).reduce((total, item) => {
        return total + getSafeDeliveryQuantity(item.ton);
    }, 0);
    const vehicleQuantity = (source.transportOrderVehicles || []).reduce((total, item) => {
        return total + getSafeDeliveryQuantity(item.transportWeight);
    }, 0);
    const railwayQuantity = (source.transportOrderRailways || []).reduce((total, item) => {
        return total + getSafeDeliveryQuantity(item.transportWeight);
    }, 0);
    return shippingQuantity + vehicleQuantity + railwayQuantity;
};
